<template>
  <div>
    <vue-element-loading :active="loader" spinner="bar-fade-scale" />
    <b-row class="match-height">
      <b-col md="6" xl="4">
        <b-card no-body class="card-browser-states">
          <b-card-header>
            <div>
              <b-card-title>Recent Blocked Domains</b-card-title>
              <b-card-text class="font-small-2 mr-25 mb-0"> Last 7 Days </b-card-text>
            </div>

            <b-dropdown variant="link" no-caret class="chart-dropdown" toggle-class="p-0">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
              </template>
              <b-dropdown-item href="#"> Last 24 Hours </b-dropdown-item>
              <b-dropdown-item href="#"> Last 7 Days </b-dropdown-item>
              <b-dropdown-item href="#"> Last 30 Days </b-dropdown-item>
            </b-dropdown>
          </b-card-header>

          <!-- body -->
          <b-card-body>
            <div class="d-flex justify-content-center">
              <span>Brand Name</span>
              <span class="ml-5">Domain</span>
              <span class="ml-auto">Processed</span>
            </div>
            <div class="d-flex justify-content-center">
              <span>Brand Name</span>
              <span class="ml-5">Domain</span>
              <span class="ml-auto">Processed</span>
            </div>
            <div class="d-flex justify-content-center">
              <span>Brand Name</span>
              <span class="ml-5">Domain</span>
              <span class="ml-auto">Processed</span>
            </div>
            <div class="d-flex justify-content-center">
              <span>Brand Name</span>
              <span class="ml-5">Domain</span>
              <span class="ml-auto">Processed</span>
            </div>
            <div class="d-flex justify-content-center">
              <span>Brand Name</span>
              <span class="ml-5">Domain</span>
              <span class="ml-auto">Processed</span>
            </div>

            <b-pagination :totalRows="10" :per-page="5" align="center" class="ml-auto mt-2"></b-pagination>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col md="6" xl="8">
        <b-card no-body class="card-statistics">
          <b-card-header>
            <b-card-title>Nawala Information</b-card-title>
            <b-card-text class="font-small-2 mr-25 mb-0"> Updated 1 month ago </b-card-text>
          </b-card-header>
          <b-card-body class="statistics-body">
            <b-row>
              <b-col xl="3" sm="6" class="mb-2 mb-xl-0">
                <b-media no-body>
                  <b-media-aside class="mr-2">
                    <b-avatar size="48" variant="danger">
                      <feather-icon size="24" icon="SlashIcon" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h4 class="font-weight-bolder mb-0">23</h4>
                    <b-card-text class="font-small-3 mb-0"> Domain Blocked </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>
              <b-col xl="3" sm="6" class="mb-2 mb-xl-0">
                <b-media no-body>
                  <b-media-aside class="mr-2">
                    <b-avatar size="48" variant="info">
                      <feather-icon size="24" icon="ColumnsIcon" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h4 class="font-weight-bolder mb-0">10</h4>
                    <b-card-text class="font-small-3 mb-0"> Active Slot </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>
              <b-col xl="3" sm="6" class="mb-2 mb-xl-0">
                <b-media no-body>
                  <b-media-aside class="mr-2">
                    <b-avatar size="48" variant="primary">
                      <feather-icon size="24" icon="BoxIcon" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h4 class="font-weight-bolder mb-0">20</h4>
                    <b-card-text class="font-small-3 mb-0"> Used Slot </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import api from "@api";

export default {
  name: `ClientDashboard`,
  data() {
    return {
      loader: false,
    };
  },
  async mounted() {},
  methods: {},
};
</script>
